import { applianceConstants } from "../_constants";

export function appliance(
  state = { fetchingDetail: false, detail: {} },
  action
) {
  switch (action.type) {
    case applianceConstants.DETAIL_REQUEST:
      return {
        fetchingDetail: true
      };
    case applianceConstants.DETAIL_SUCCESS:
      return {
        fetchingDetail: false,
        detail: action.detail
      };
    case applianceConstants.DETAIL_FAILURE:
      return {};
    default:
      return state;
  }
}
